<template>
  <div class="productCenter">
    <header>
      <Navbar />
    </header>
    <div class="product-header">
      <div class="product_bannnerText">
        <div>产品中心</div>
        <div>
          展华科技紧扣时代脉搏，持续走创新发展的道路，已经获得包括HIS、电子病历、集成平台、智慧医疗、综合运营管理、区域医疗等在内的数十项自主知识产权产品国家级认证。
        </div>
      </div>
    </div>

    <div class="productCont">
      <div class="pth">
        <div class="rerurn" @click="goHome">
          <div>返回上一级</div>
          <div class="returnLeve"><img :src="returnLeve" /></div>
        </div>
      </div>
      <div class="productTitle">
        <div>展华产品</div>
        <div class="redline"></div>
      </div>
      <div class="productText">
        <div @click="goMedical" class="imgList"><img :src="medical" /></div>
        <div @click="goService" class="imgList"><img :src="service" /></div>
        <div @click="goOperaing" class="imgList"><img :src="operaing" /></div>
        <div @click="goInter" class="imgList"><img :src="inter" /></div>
      </div>
    </div>
    <footer>
      <Root />
    </footer>
  </div>
</template>
<script src="//unpkg.com/vue/dist/vue.js"></script>
<script src="//unpkg.com/element-ui@2.15.7/lib/index.js"></script>
<script>
import Navbar from "../../layout/Navbar.vue";
import Root from "../../layout/root.vue";
import medical from "../../assets/medical.png";
import productCenterBanner from "../../assets/productCenterBanner.png";
import operaing from "../../assets/operaing.png";
import inter from "../../assets/inter.png";
import service from "../../assets/service.png";
import returnLeve from "../../assets/returnLeve.png";
export default {
  name: "peoductCenter",
  components: {
    Navbar,
    Root,
  },
  data() {
    return {
      medical: medical,
      productCenterBanner: productCenterBanner,
      operaing: operaing,
      inter: inter,
      service: service,
      returnLeve: returnLeve,
    };
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/" });
    },
    goMedical() {
      this.$router.push({ path: "medical" });
    },
    goService() {
      this.$router.push({ path: "service" });
    },
    goOperaing() {
      this.$router.push({ path: "operaing" });
    },
    goInter() {
      this.$router.push({ path: "inter" });
    },
  },
};
</script>
<style scoped>
footer {
  height: 520px;
  margin-top: 30px;
}
header {
  background-color: #ffffff;
}
.product-header {
  position: relative;
  height: 420px;
  width: 100%;
  margin: 0 auto;
  background: url("../../assets/productCenterBanner.png") no-repeat;
  background-size: cover;
  background-position: center;
}
.product_bannnerText {
  position: absolute;
  left: 7.5%;
  top: 113px;
}
.product_bannnerText :nth-child(1) {
  font-size: 52px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.product_bannnerText :nth-child(2) {
  width: 64%;
  font-size: 18px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 200;
  margin-top: 33px;
}
.productCont {
  width: 85%;
  margin: 0 auto;
  margin-top: 30px;
  display: block;
}
.productTitle {
  text-align: center;
  font-size: 28px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 12px;
}
.redline {
  width: 60px;
  height: 6px;
  margin: 0 auto;
  margin-top: 20px;
  background-color: #e52f22;
}
.productText {
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
}
.imgList img {
  cursor: pointer;
}
.rerurn {
  cursor: pointer;
  float: right;
  display: flex;
  height: 30px;
  font-size: 16px;
  color: #767b8d;
  letter-spacing: 0;
  text-align: right;
  font-weight: 400;
}
.returnLeve {
  margin-left: 10px;
}
.pth {
  height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/views/productCenter/index.vue